import { render, staticRenderFns } from "./transferStat.vue?vue&type=template&id=279d8fbe&"
import script from "./transferStat.vue?vue&type=script&lang=js&"
export * from "./transferStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transferStat.vue"
export default component.exports